// extracted by mini-css-extract-plugin
export default {"status":"Select_status__0rp1E"};